import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Spin } from "antd";
import { handleLoginSession, login, saveOtp } from "../../features/auth/authSlice";
import Header from "./Header"; 
import toast from "react-hot-toast"; 
import RightSide from "./RightSide"; 
import { useEffect, useRef, useState } from "react";
import svg72 from '../../assets/svg/svg72.svg'

export default function LoginOtpCode() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { authLoading, loginInfo,saving } = useSelector((state) => state.auth);
  const formRef = useRef(null);
  const [counter, setCounter] = useState({ minutes: 0, seconds: 59 });
 
  const onFinish = async (data) => {
    const requestData = {
      ...data,
      usrOrgCode: loginInfo?.usrOrgCode,
      userEmail: loginInfo?.userEmail,
      password: loginInfo?.password,
    };
    const res = await dispatch(login(requestData));
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);

      const { orgStatus, accessToken, refreshToken } =
        res?.payload?.data?.result;

      if (
        ["PENDING", "REJECTED", "PENDING_APPROVAL", "APPROVED"].includes(
          orgStatus
        )
      ) {
        await localStorage.setItem("token", accessToken);  
        await dispatch(handleLoginSession(true));
        await form.resetFields();

        const route =
          orgStatus === "APPROVED" ? "/choose-screen" : "/company-account-profile";
        await navigate(route);
      }
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

   const handleResendOtp = async () => {
      const res = await dispatch(
        saveOtp({
          usrId: loginInfo?.usrId,
          url: `auth/resend-otp`,
        })
      );
      if (res?.payload?.success) {
          setCounter({ minutes: 0, seconds: 59 });
        toast.success(res.payload?.messages?.message);
      } else { 
        toast.error(res.payload?.messages?.message);
      }
    }; 

  useEffect(() => {
    const interval = setInterval(() => {
      if (counter.minutes === 0 && counter.seconds === 0) {
        clearInterval(interval);
      } else {
        setCounter((prevCounter) => {
          if (prevCounter.seconds === 0) {
            return { minutes: prevCounter.minutes - 1, seconds: 59 };
          } else {
            return { ...prevCounter, seconds: prevCounter.seconds - 1 };
          }
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [counter, authLoading]);
  return (
    <>
      <div className="flex w-full min-h-screen bg-white">
        <div className="flex flex-col w-full ">
          <Header /> 
         
          <div className="w-full h-full flex flex-col items-center justify-center">
            <div className="w-full max-w-[32.25rem] flex flex-col lg:px-0 px-3">
              <span className="heading-verify items-start justify-start flex">
                Verify Account
              </span>
              <span className="paragraph_1">
                Enter the 4 digit code sent to your phone or email
              </span>

              <Form
                layout="vertical"
                ref={formRef}
                name="control-ref"
                onFinish={onFinish}
                style={{
                  maxWidth: "100%",
                  marginTop: "2.06rem",
                  width: "100%",
                }}
                form={form}
              >
                <Form.Item
                  name="usrSecret"
                  label="Code"
                  rules={[
                    {
                      required: true,
                      message: "Otp code is required to login",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter code sent to your phone"
                    className="input"
                  />
                </Form.Item>

                <div className="w-full flex flex-col">
                  <div className="flex mt-[1.63rem]">
                    <button
                      className="cstm-btn-2 !bg-[#000000]"
                      type="submit"
                      disabled={authLoading ? true : false}
                    >
                      {authLoading ? <Spin /> : "Login"}
                    </button>
                  </div>

                  <div className="mt-[2rem] flex items-center justify-center w-full font-lexendS ">
                    {counter.minutes === 0 && counter.seconds === 0 ? (
                      <button
                        disabled={saving}
                        className="text-[#000] font-[300] text-[14px]  cursor-pointer"
                        onClick={handleResendOtp}
                        type="button"
                      >
                        Didn’t receive code?
                      </button>
                    ) : (
                      <span className="underline text-[#DB2A12] font-[500]">
                        Resend in {counter.minutes.toString().padStart(2, "0")}:
                        {counter.seconds.toString().padStart(2, "0")}
                      </span>
                    )}
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
        <RightSide />
      </div>
    </>
  );
}
